import { useQuery, QueryClient } from '@tanstack/react-query';
import { AxiosRequestConfig } from 'axios';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from 'queries/contests/queryKey';

export const useGetContestVoteContentsQuery = (contestId: number, enabled = false) =>
  useQuery({
    queryKey: contestsQueryKey.contestsVoteContents(contestId),
    queryFn: () => ContestApi.getVoteContents(contestId),
    enabled,
  });

export const prefetchContestVoteContentsQuery = async (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  contestId: number,
) =>
  queryClient.prefetchQuery({
    queryKey: contestsQueryKey.contestsVoteContents(contestId),
    queryFn: () => ContestApi.getVoteContents(contestId, options),
  });
